// src/App.js

import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import AOS from 'aos';

import Home from './pages/main/Home';
import Services from './pages/main/Services';
import Permis from './pages/main/Permis';
import Job from './pages/main/Job';
import Quote from './pages/main/Quote';
import CoursesScolaires from './pages/services/CoursesScolaires';
import NavetteAeroport from './pages/services/NavetteAeroport';
import TransportColis from './pages/services/TransportColis';
import TransportMedical from './pages/services/TransportMedical';
import MobiliteReduite from './pages/services/MobiliteReduite';
import StationsSki from './pages/services/StationsSki';
import Confidentialite from './pages/terms/Confidentialite';
import Conditions from './pages/terms/Conditions';
import Cookies from './pages/terms/Cookies';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      disable: 'mobile'
    });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/permis" element={<Permis />} />
        <Route path="/job" element={<Job />} />
        <Route path="/quote" element={<Quote />} />
        <Route path="/services/courses-scolaires" element={<CoursesScolaires />} />
        <Route path="/services/navette-aeroport" element={<NavetteAeroport />} />
        <Route path="/services/transport-colis" element={<TransportColis />} />
        <Route path="/services/transport-medical" element={<TransportMedical />} />
        <Route path="/services/mobilite-reduite" element={<MobiliteReduite />} />
        <Route path="/services/stations-ski" element={<StationsSki />} />
        <Route path="/privacy" element={<Confidentialite />} />
        <Route path="/terms" element={<Conditions />} />
        <Route path="/cookies" element={<Cookies />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
